import { render, staticRenderFns } from "./ProjectSite.vue?vue&type=template&id=090f3636&"
import script from "./ProjectSite.vue?vue&type=script&lang=js&"
export * from "./ProjectSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/michaelzickert/Development/capture-studio/capture-studio-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('090f3636')) {
      api.createRecord('090f3636', component.options)
    } else {
      api.reload('090f3636', component.options)
    }
    module.hot.accept("./ProjectSite.vue?vue&type=template&id=090f3636&", function () {
      api.rerender('090f3636', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ProjectSite.vue"
export default component.exports